import {Box, Typography, Stack} from "@mui/material";
import SuggestionListUI from "./SuggestionListUI";
import {SymbolCodepoints} from "react-material-symbols";
import {useGetProfileQuery} from "../../../../store/api/userApiSlice";

// Array of suggestion items
const suggestionItems = [
  {
    id: "1",
    leadingIcon: "robot_2" as SymbolCodepoints,
    title: "What can Genie do",
    subtitle: "to help you with the question",
    value: "What can Genie do to help you with the question",
  },
  {
    id: "2",
    leadingIcon: "lightbulb" as SymbolCodepoints,
    title: "Get a hint",
    subtitle: "stuck on a question? ask Genie for a nudge",
    value: "Tell me a hint to help me with the question",
  },
  {
    id: "3",
    leadingIcon: "function" as SymbolCodepoints,
    title: "Ask for a formula",
    subtitle: "get the exact formula you need",
    value: "Tell me the formula for ",
  },
  {
    id: "4",
    leadingIcon: "quick_reference_all" as SymbolCodepoints,
    title: "Summarize the question",
    value: "Summarize the question and highlight the key information",
  },
];

export default function EmptyBodyUI({
  onSuggestionItemClick,
}: {
  onSuggestionItemClick: (value: string) => void;
}) {
  const {data: userData} = useGetProfileQuery();
  return (
    <Box mx={1}>
      <Stack direction="column" sx={STYLES.emptyBodyHeaderContainer}>
        {/* <Typography sx={STYLES.emptyBodyTitle}>
          Hello, {userData?.profile?.firstName}
        </Typography> */}
        <Typography
          sx={STYLES.emptyBodySubtitle}
          color={"primary.contrastText"}>
          How can I help you with this question?
        </Typography>
      </Stack>

      <Box height={8} />
      <SuggestionListUI
        suggestionItems={suggestionItems}
        onSuggestionItemClick={onSuggestionItemClick}
      />
    </Box>
  );
}

const STYLES = {
  emptyBodyHeaderContainer: {
    fontSize: "1.5rem",
    fontWeight: 600,
    letterSpacing: "-.75px",
    mx: 1,
  } as const,
  emptyBodyTitle: {
    lineHeight: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    letterSpacing: "inherit",
    background: "linear-gradient(135deg, #217bfe 0, #078efb 33%, #ac87eb 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    width: "fit-content",
  } as const,
  emptyBodySubtitle: {
    opacity: 0.7,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    // fontSize: "inherit",
    fontWeight: "inherit",
    letterSpacing: "inherit",
  } as const,
};
